// export default () => ({
// })

export default () => ({
    inputdetails: [],
    inputdetailsSelectable: [],
    inputdetailsPaginatedData: null,
    inputdetail: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
    selectedListData: null,
    isSelecting: false,
})